import { useMemo } from 'react';
import { useGetUserGoogleAccountsQuery } from 'services/userGoogleAccountsV2';

export function useGoogleSync(options = {}) {
  const {
    data: accounts = [],
    isLoading,
    isFetching,
    refetch,
  } = useGetUserGoogleAccountsQuery(undefined, { ...options });

  const account = Array.isArray(accounts) && accounts.length > 0 ? accounts[0] : null;

  const googleSync = useMemo(
    () => ({
      id: account?.id,
      syncStatus: account?.syncStatus || 'not_connected',
      contactsSynced: account?.contactsSynced || 0,
      lastSyncedAt: account?.lastSyncedAt,
      scopes: account?.scopes || [],
    }),
    [account],
  );

  const isConnected = Boolean(account);
  const hasSynced = Boolean(account?.lastSyncedAt) || (account?.contactsSynced || 0) > 0;

  return { accounts, account, googleSync, isConnected, hasSynced, isLoading, isFetching, refetch };
}
